import {
    COMPETITIONS_RESULT_FAILURE,
    COMPETITIONS_RESULT_REQUEST,
    COMPETITIONS_RESULT_SUCCESS,
    COMPETITIONS_DELETE_DRAW_SUCCESS,
    COMPETITIONS_MAKE_DRAW_SUCCESS, COMPETITION_RESULT_PATCH_SUCCESS,
    COMPETITION_RESULT_WINNER_SUCCESS,
    CATEGORY_RESULTS_REFRESHED,
    DRAW_RESET_SUCCESS,
    DRAW_SWAP_SUCCESS,
    POINTS_STAGE_RESET_SUCCESS,
    SCORE_ENTRY_SUCCESS,
    SCORE_ROUND_COMPLETE_SUCCESS,
    SCORE_ROUND_REOPEN_SUCCESS,
    SCORE_TIE_BREAK_SUCCESS,
    ATTENDANCE_SAVE_SUCCESS,
    ATTENDANCE_BULK_SUCCESS,
} from 'actions';

const initialState = {
    data: [],
    isFetched: [],
    isFetching: [],
    stale: [],
};

export const competitionResultListReducer = (state = initialState, action) => {
    const {type, data: responseData, category, competition, result, results, competitionId} = action;
    const {data, isFetched, isFetching, stale = []} = state;
    switch (type) {
        // Attendance Check-In: a single edit or a bulk change may have
        // auto-advanced a bracket server-side (BracketProgressionService::
        // applyAttendanceWithdrawal, via AttendanceWorkflowSubscriber) —
        // nothing in the attendance response carries the updated draw rows,
        // so mark this competition's rows stale for a refetch instead.
        case ATTENDANCE_SAVE_SUCCESS:
        case ATTENDANCE_BULK_SUCCESS: {
            return {
                ...state,
                stale: [...stale.filter(id => id !== competitionId), competitionId],
            };
        }
        // The backend re-derived the whole category draw (winner advanced /
        // draft swap / draft reset) — swap the category rows wholesale so
        // the bracket can never show a stale athlete.
        case COMPETITION_RESULT_WINNER_SUCCESS:
        case CATEGORY_RESULTS_REFRESHED:
        case DRAW_SWAP_SUCCESS:
        case DRAW_RESET_SUCCESS:
        case SCORE_ENTRY_SUCCESS:
        case SCORE_TIE_BREAK_SUCCESS:
        case SCORE_ROUND_COMPLETE_SUCCESS:
        case SCORE_ROUND_REOPEN_SUCCESS:
        case POINTS_STAGE_RESET_SUCCESS: {
            const keptData = data.filter(d => !(d.category.id === category && d.competition.id === competition));
            return {
                ...state,
                data: [...keptData, ...results],
            }
        }

        case COMPETITIONS_DELETE_DRAW_SUCCESS: {
            const newData = state.data.filter(d => !(d.category.id === category && d.competition.id === competition));
            return {
                ...initialState,
                data: newData,
            }
        }

        case COMPETITIONS_MAKE_DRAW_SUCCESS: {
            return {
                ...initialState,
                data: [...data, ...result],
            }
        }

        case COMPETITION_RESULT_PATCH_SUCCESS: {
            return {
                ...state,
                data: data.map(d => d.id === result.id ? result : d)
            }
        }

        case COMPETITIONS_RESULT_SUCCESS: {
            // Dedup-safe: a stale-triggered refetch (see ATTENDANCE_*_SUCCESS
            // above) re-requests a competition already in `data` — drop its
            // old rows first, or the bracket would render two copies of the
            // same slot.
            const keptData = data.filter(d => d.competition.id !== competition);
            return {
                ...state,
                isFetched: [...isFetched.filter(id => id !== competition), competition],
                isFetching: isFetching.filter(id => id !== competition),
                stale: stale.filter(id => id !== competition),
                data: [...keptData, ...responseData],
            };
        }

        case COMPETITIONS_RESULT_REQUEST: {return {
            ...state,
            isFetching: [...isFetching, competition],
        }}

        case COMPETITIONS_RESULT_FAILURE: {return {
            ...state,
        }}

        default: {return state}
    }
};
